import React, { useEffect, useState } from 'react'
import { commonActions, faqActions } from '../../store/actions'
import { connect } from 'react-redux'
import history from '../../route/history'

const FaqList = (props) => {
  const queryString = require('query-string')
  const [cteCode, setCteCode] = useState()
  const [state, setState] = useState({
    schText: '',
  })
  const [text, setText] = useState('전체')

  useEffect(() => {
    props.getCommonCode({ mainCd: 'QNA_CATEGORY_CD' })
  }, [])

  useEffect(() => {
    setCteCode(props.cteCode)
  }, [props.cteCode])

  useEffect(() => {
    setText(document.getElementById('cteCode').options[document.getElementById('cteCode').selectedIndex].text)
  })

  useEffect(() => {
    const parsed = queryString.parse(props.search)

    setState(parsed)
    props.load(parsed)
  }, [props?.search])

  const handleChange = (e) => {
    const { name, value } = e.target
    setState({
      ...state,
      [name]: value,
    })
  }

  const handleKeyPress = (e) => {
    deleteOn()
    if (e.key === 'Enter') {
      props.load({ cteCode: state.cteCode, schText: state.schText })
    }
  }

  const changeTab = (e) => {
    const { name, value } = e.target
    state.cteCode = value
    deleteOn()
    searchList(value)
    setText(document.getElementById('cteCode').options[document.getElementById('cteCode').selectedIndex].text)
  }

  const searchList = (cteCode) => {
    cteCode = cteCode !== '전체' ? cteCode : ''
    let searchInfo = { cteCode }
    state.schText?.length > 0 && (searchInfo.schText = state.schText)

    let paramStr = queryString.stringify(searchInfo)
    paramStr.length > 0 && (paramStr = '?' + paramStr)
    history.push('/faq' + paramStr)
  }

  const clickEvent = (e) => {
    if (e.target.nextSibling.classList.contains('on')) {
      e.target.nextSibling.classList.remove('on')
    } else {
      e.target.nextSibling.className += ' on'
    }
  }

  const mobileSelectBoxEvent = (e) => {
    e.preventDefault()
    e.target.classList.toggle('on')
  }

  function deleteOn() {
    const els = document.querySelectorAll('.collapse')
    for (var i = 0; i < els.length; i++) {
      els[i].classList.remove('on')
    }
  }

  useEffect(() => {
    document.getElementById('mcm2').classList.remove('on')
  }, [text])

  return (
    <React.Fragment>
      <section>
        <div className="search-box center">
          <div className="row">
            <select title="카테고리" name="cteCode" className="form-category3" id="cteCode" onChange={changeTab} value={state.cteCode}>
              <option>전체</option>
              {cteCode?.map((item) => {
                return (
                  <option key={item.cd} value={item.cd}>
                    {item.cdName}
                  </option>
                )
              })}
            </select>

            <div className="inquiry-group">
              <input
                type="text"
                title="검색"
                className="form-keyword"
                placeholder="검색어를 입력하세요"
                id="schText"
                name="schText"
                value={state.schText || ''}
                onChange={handleChange}
                onKeyPress={handleKeyPress}
              />

              <button
                className="btn-search"
                onClick={() => {
                  props.load({ cteCode: state.cteCode, schText: state.schText })
                  deleteOn()
                }}
              >
                검색
              </button>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="accordion faq-accordion__list">
          <input
            type="radio"
            id="tab-all"
            title="FAQ-tab"
            name="FAQ-tab"
            onChange={changeTab}
            value=""
            // defaultChecked={true}
            checked={!state.cteCode}
            style={{ display: 'none' }}
          />

          {cteCode?.map((cte) => {
            return (
              <input
                type="radio"
                key={'tab-' + cte?.cd}
                id={'tab-' + cte?.cd}
                title="FAQ-tab"
                name="FAQ-tab"
                onChange={changeTab}
                value={cte?.cd}
                checked={state.cteCode === cte?.cd}
                style={{ display: 'none' }}
              />
            )
          })}
          <div className="nav-tab mt35">
            <ul>
              <li id="all" className={'' === state.cteCode || undefined === state.cteCode ? 'on' : ''}>
                <button onClick={() => document.getElementById('tab-all').click()} className="tab-all">
                  전체
                </button>
              </li>
              {cteCode?.map((cte) => {
                return (
                  <li key={cte.cd} className={cte.cd === state.cteCode ? 'on' : ''}>
                    {/* htmlFor={'tab-' + cte?.cd} */}
                    <button type="button" onClick={() => document.getElementById('tab-' + cte?.cd).click()} className={'tab-' + cte?.cd}>
                      {cte.cdName}
                    </button>
                  </li>
                )
              })}
            </ul>
          </div>

          {/* mobile */}
          <div className="nav-wrap">
            <label id="mcm2" className="current-menu2" onClick={mobileSelectBoxEvent}>
              {text !== '전체' ? text : '전체'}
            </label>
            <ul className="nav-menu">
              <li className={!state.cteCode ? 'on' : ''} style={{ textAlign: 'center', marginBottom: '10px' }}>
                <label htmlFor="tab-all" onChange={changeTab}>
                  전체
                </label>
              </li>
              {cteCode?.map((item) => {
                return (
                  <li
                    key={'m' + item.cd}
                    className={item.cd === state.cteCode ? 'on' : ''}
                    style={{ textAlign: 'center', marginTop: '10px', marginBottom: '10px' }}
                  >
                    <label htmlFor={'tab-' + item?.cd} className={'tab-' + item?.cd} onChange={changeTab}>
                      {item.cdName}
                    </label>
                  </li>
                )
              })}
            </ul>
          </div>

          <div className="accordion">
            {props?.list?.length > 0 ? (
              props?.list?.map((faq, index) => (
                <div className="row" key={index}>
                  <div className="title" id={index} onClick={clickEvent}>
                    {faq.faqSj}
                  </div>
                  <div className="collapse">{faq.faqText}</div>
                </div>

                // <div className="row" key={index}>
                //   <div className="cell" data-title="번호">
                //     {notice.noticeSeq}
                //   </div>
                //   <div className="cell left" data-title="제목">
                //     <Link to={'/faq/' + faq.noticeSeq}>{notice.noticeSj}<span className="icon-file m-l-10"></span></Link>
                //   </div>
                // </div>
              ))
            ) : (
              <div>등록된 자료가 없습니다.</div>
            )}
          </div>
        </div>
      </section>
    </React.Fragment>
  )
}

const mapStateToProps = (state) => {
  return {
    list: state.faq.data,
    cteCode: state.commoncode?.co?.QNA_CATEGORY_CD,
  }
}
const actionCreators = {
  load: faqActions.load,
  getCommonCode: commonActions.getCommonCode,
}

export default connect(mapStateToProps, actionCreators)(FaqList)
